import { SLOTS } from 'types';
import { BetType } from './types';

export const EMPTY_BET: BetType = {
  [SLOTS.player]: 0,
  [SLOTS.tie]: 0,
  [SLOTS.banker]: 0,
};
